import { AgentMlsIdResource } from "api/resource/agent-mls-id";
import { AgentMlsIds } from "model/agent-mls-ids";
import { entriesOf } from "shared/agent-mls-ids";

// Per board: the agent's MLS IDs (each row its own record, possibly several), and the strays, which "need your review".
// On an office-sourced account, where the model doesn't apply, an agent's only MLS ID on a board is theirs, and several
// all need review, so each is listed with the strays and can be removed.
interface ProfileBoard {
	boardId: number;
	// The board is waiting on paperwork approval.
	pending: boolean;
	ids: AgentMlsIdResource[];
	strays: AgentMlsIdResource[];
}

export const profileSplit = (agentMlsIds: AgentMlsIds, agentId: number): ProfileBoard[] => {
	return agentMlsIds.boards.map(({ boardId, pending }) => {
		const entries = entriesOf(agentMlsIds, agentId, boardId);
		if (agentMlsIds.officeAccount) {
			return { boardId, pending, ids: entries.length === 1 ? entries : [], strays: entries.length > 1 ? entries : [] };
		}
		const stray = (entry: AgentMlsIdResource) => agentMlsIds.clientBoardLinks.get(entry.id)!.state === "stray";
		return { boardId, pending, ids: entries.filter((entry) => !stray(entry)), strays: entries.filter(stray) };
	});
};
